import React from "react";
import { useTranslation } from "react-i18next";
import "./scss/Privacy.scss";

const Privacy = () => {
  const { t } = useTranslation();
  document.title = `Gudema - ${t("privacy.title")}`;

const privacyHeadings = [
  "UAB GUDEMA PRIVATUMO POLITIKA",
  "Privatumas",
  "Asmens duomenų rinkimas ir naudojimas",
  "Asmens duomenų apsauga",
  "Asmens duomenų atskleidimas tretiesiems asmenims",
  "Speciali informacija apie profesinių klientų darbuotojų privatumą",
  "Privatumo politika, susijusi su mūsų svetainėmis",
  "Prisijungimo duomenys",
  "UAB Gudema komercinių el. laiškų stebėjimas",
  "UAB Gudema svetainių naudojimo analizė",
  "Mūsų privatumo politikos pakeitimai",
  "UAB Gudema kontaktiniai duomenys",

  "1. Who we are",
  "2. What personal data we collect",
  "3. How we use your data",
  "4. Legal basis for processing",
  "5. Analytics and cookies",
  "6. Email marketing, Mailchimp",
  "7. Sharing your data",
  "8. International data transfers",
  "9. Data retention",
  "10. Access and internal support",
  "11. Social media and external links",
  "12. Your rights",
  "13. Security",
  "14. Changes to this privacy statement",

  "Account and contact data",
  "Account and platform data",
  "Usage and analytics data",
  "Communication data",
  "Cookie consent",
  "Analytics, Google Analytics",
  "Data storage, BigQuery",

  "1. Keitä olemme",
  "2. Mitä henkilötietoja keräämme",
  "3. Miten käytämme tietojasi",
  "4. Käsittelyn oikeusperuste",
  "5. Tietojen säilyttäminen",
  "6. Pääsy tietoihin ja sisäinen tuki",
  "7. Sosiaalinen media ja ulkoiset linkit",
  "8. Oikeutesi",
  "9. Turvallisuus",
  "10. Muutokset tähän tietosuojaselosteeseen",
  "Tili- ja yhteystiedot",
  "Tili- ja alustatiedot",

  "1. Кто мы",
  "2. Какие персональные данные мы собираем",
  "3. Как мы используем ваши данные",
  "4. Правовое основание обработки",
  "5. Хранение данных",
  "6. Доступ и внутренняя поддержка",
  "7. Социальные сети и внешние ссылки",
  "8. Ваши права",
  "9. Безопасность",
  "10. Изменения в настоящем заявлении о конфиденциальности",
  "Данные учетной записи и контактные данные",
  "Данные учетной записи и платформы"
];

const renderPrivacyText = (text) => {
  const lines = String(text || "").split("\n");
  const result = [];
  let listItems = [];

  const flushList = () => {
    if (listItems.length) {
      result.push(
        <ul key={`ul-${result.length}`} className="privacy-page__list">
          {listItems.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      );

      listItems = [];
    }
  };

  lines.forEach((line, index) => {
    const trimmed = line.trim();

    if (!trimmed) {
      flushList();
      return;
    }

    if (trimmed.startsWith("- ")) {
      listItems.push(trimmed.substring(2));
      return;
    }

    flushList();

    if (privacyHeadings.includes(trimmed)) {
      result.push(
        <p key={index} className="privacy-page__heading">
          {line}
        </p>
      );
      return;
    }

    result.push(
      <p key={index} className="privacy-page__text">
        {line}
      </p>
    );
  });

  flushList();

  return result;
};

  
  return (
    <main className="privacy-page">
      <div className="privacy-page__container">
        <h1>{t("privacy.title")}</h1>

        <h2>{t("privacy.subtitle")}</h2>

        <div className="privacy-page__content">
        {renderPrivacyText(t("privacy.text"))}
      </div>
      </div>
    </main>
  );
};

export default Privacy;
